import {
  FoodCostReportState,
  FoodCostSortOptions,
  FoodCostTarget,
} from '@usf/ngrx-inventory';
import { RadioBtnInventory } from '../../../models/radio-btn-inventory.model';

export enum FoodCostRangeLoadingState {
  success = 'success',
  error = 'error',
  loading = 'loading',
}
export interface FoodCostViewModel {
  inventories: RadioBtnInventory[];
  foodCostReports: FoodCostReportState[];
  trendsTileData: any;
  graphData: any;
  itemSize: number;
  // TODO: Update user types library so we dont have to cast to any
  foodCostRange: any;
  hasFoodCostRange: boolean;
  showFoodCostRange: boolean;
  sortOptions: FoodCostSortOptions;
  overviewData: FoodCostOverviewData;
}

export interface FoodCostOverviewData {
  // TODO: Update user types library so we dont have to cast to any
  foodCostRange: any;
  startValue: number;
  startDate: string | Date;
  endValue: number;
  endDate: string | Date;
  rangeAndDataReady: boolean;
  reportsReady: boolean;
  targetState: FoodCostTarget;
}

export interface FoodCostTotalData {
  departmentNumbers: string;
  inventoryStartDate: string;
  inventoryEndDate: string;
  excludeClass?: string;
}
